var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./IndexSlider.jinja');
require('./IndexSlider.less');

module.exports = Base.extend({

    template: template,


    events: {
        'click .IndexSlider-slidesPrev': 'gotoPrev',
        'click .IndexSlider-slidesNext': 'gotoNext',
        'click .IndexSlider-dot': 'gotoSlide',
        'click a': 'onLinkClick'
    },


    initialize: function (options) {
        this.options = options || {};

        this.onResize = _.debounce(this.onResize, 200);

        _.bindAll(this, 'autochangeNext', 'onResize');

        this.activeSlide = 0;

        this.slidesCount = this.$('.IndexSlider-slide').length;

        var dots = Array(this.slidesCount + 1).join('<div class="IndexSlider-dot"></div>');
        this.$('.IndexSlider-dots').append(dots);

        if (app.settings.isPhone) {
            this.$el.swipe( {
                allowPageScroll: 'vertical',
                threshold: 50,
                swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                    if (direction == 'left') {
                        this.gotoNext();
                    }
                    if (direction == 'right') {
                        this.gotoPrev();
                    }
                }.bind(this)
            });
        }

        this.autochangeInterval = setInterval(this.autochangeNext, 7000);
        this.updateState();

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        $(window).on('resize', this.onResize);

        this.onResize();
    },


    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        return Base.prototype.destroy.call(this, params);
    },


    onResize: function() {
        var maxRows = 0;
        var lineHeight, rows;
        this.$('.IndexSlider-slideInfo h3 span').each(function(ind, item) {
            lineHeight = parseFloat(window.getComputedStyle(item).getPropertyValue('line-height'));
            rows = Math.round(item.getBoundingClientRect().height / lineHeight);
            if (rows > maxRows) maxRows = rows;
        }.bind(this));

        var additionalHeight = (maxRows - 2) * lineHeight;
        this.$el.css('padding-bottom', additionalHeight + 'px');
        console.log(additionalHeight);
    },


    onLinkClick: function () {
        clearInterval(this.autochangeInterval);
    },


    gotoPrev: function () {
        clearInterval(this.autochangeInterval);

        this.activeSlide = (this.activeSlide - 1 + this.slidesCount) % this.slidesCount;

        this.updateState();
    },


    gotoNext: function () {
        clearInterval(this.autochangeInterval);

        this.activeSlide = (this.activeSlide + 1 + this.slidesCount) % this.slidesCount;

        this.updateState();
    },


    autochangeNext: function () {
        this.activeSlide = (this.activeSlide + 1 + this.slidesCount) % this.slidesCount;

        this.updateState();
    },


    gotoSlide: function (e) {
        clearInterval(this.autochangeInterval);

        this.activeSlide = $(e.currentTarget).index();

        this.updateState();
    },


    updateState: function () {
        this.$('.IndexSlider-slide').removeClass('IndexSlider-slide--active');
        this.$('.IndexSlider-slide')
            .eq(this.activeSlide)
            .addClass('IndexSlider-slide--active');

        this.$('.IndexSlider-dot').removeClass('IndexSlider-dot--active');
        this.$('.IndexSlider-dot')
            .eq(this.activeSlide)
            .addClass('IndexSlider-dot--active');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSlider/IndexSlider.js
// module id = 182
// module chunks = 0